<template>
    <section id="page-wil-combineren" class="page-wil-combineren page">
        <div class="page__content">
            <h1>Waar wil jij je huidige werk mee combineren?</h1>
            <div class="container list-select">
                <div class="list-select__item row" v-for="type in jobTypes"
                     v-bind:class="{'list-select__item--selected': type === newJob}"
                     @click="selectType(type)">
                    <div class="col-2-sm list-select__item-marker-column">
                        <div class="list-select__item-marker"></div>
                    </div>
                    <div class="col-10-sm list-select__item-text">
                        {{type.label}}
                    </div>
                </div>
                <div class="row" v-if="newJob">
                    <div class="col-2-sm"></div>
                    <div class="col-10-sm list-select__title">
                        <button class="button" v-on:click="nextHandler">Volgende</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style lang="stylus">
    .page-wil-combineren .list-select
        margin-bottom 30px;
</style>
<script>
    import page from './page';

    export default {
        mixins: [page],
        props: {
            jobTypes: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                newJob: null,
                submitted: false
            }
        },
        methods: {
            selectType(type) {
                this.newJob = type;
                this.$emit('profileupdate', { key: 'baan2', value: type});
            },
            submitHandler() {
                this.submitted = true;
            }
        }

    }
</script>



// WEBPACK FOOTER //
// page-wil-combineren.vue?aa7fbd66